import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddCircleBlue, FullTable, CustomDelete } from 'components';
import { FindSuccessItem, Images, useModal } from 'utils';
import { httpRequestsOnSuccessActions, systemActions } from 'store';
import { AddCompany } from './modals';
import { companyBody, companyHead, companyNotYet } from './constants';

const ACTION_TYPE = 'GET_COMPANIES';
const CREATE_ACTION_TYPE = 'CREATE_COMPANY';
const EDIT_ACTION_TYPE = 'EDIT_COMPANY';
const DELETE_ACTION_TYPE = 'DELETE_COMPANY';

export const Company = () => {
    const { open, close } = useModal();
    const dispatch = useDispatch();
    const companies = useSelector((state) => state.system.companies);
    const createSuccess = FindSuccessItem(CREATE_ACTION_TYPE);
    const editSuccess = FindSuccessItem(EDIT_ACTION_TYPE);
    const deleteSuccess = FindSuccessItem(DELETE_ACTION_TYPE);

    useEffect(() => {
        dispatch(systemActions.getCompanies());
    }, []);

    useEffect(() => {
        if (createSuccess || editSuccess || deleteSuccess) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(CREATE_ACTION_TYPE));
            dispatch(httpRequestsOnSuccessActions.removeSuccess(EDIT_ACTION_TYPE));
            dispatch(httpRequestsOnSuccessActions.removeSuccess(DELETE_ACTION_TYPE));
            dispatch(systemActions.getCompanies('noLoad'));
            close();
        }
    }, [createSuccess, editSuccess, deleteSuccess]);

    const handleAction = (item, name) => {
        if (name === 'edit') {
            open(<AddCompany info={item} />);
        }
        if (name === 'delete') {
            open(
                <CustomDelete
                    text="Are you sure you want to delete your company information? This action cannot be undone."
                    info="Delete Company Info?"
                    handleDel={() => dispatch(systemActions.deleteCompany(item?.id))}
                    actionType={DELETE_ACTION_TYPE}
                    body={
                        <div className="deleting-client-info-box" style={{ alignItems: 'flex-start' }}>
                            <img
                                style={{
                                    marginTop: '3px',
                                    filter: 'brightness(0) saturate(100%) invert(13%) sepia(20%) saturate(3519%) hue-rotate(191deg) brightness(94%) contrast(92%)',
                                }}
                                src={Images.officeBlueIcon}
                                alt="icon"
                            />
                            <p style={{ fontWeight: 400 }}>{item?.name}</p>
                        </div>
                    }
                />
            );
        }
    };

    return (
        <div>
            <div className="header-action-btn">
                <AddCircleBlue text={'Add Company'} handleClick={() => open(<AddCompany />)} />
            </div>
            <FullTable
                head={companyHead}
                body={companyBody}
                loadingType={ACTION_TYPE}
                // list={sortListByKey(bankList, 'name') || []}
                list={companies || []}
                handleClickButton={handleAction}
                notYet={companyNotYet}
                margin={'0'}
            />
        </div>
    );
};
